import { ISelectOption } from 'interfaces';

export const enum RELEVANCES {
  ONE_DAY = '1day',
  THREE_DAYS = '3days',
  ONE_WEEK = '1week',
  ONE_MONTH = '1month',
  THREE_MONTHS = '3months',
  SIX_MONTHS = '6months',
  ONE_YEAR = '1year',
  ALL_TIME = 'allTime',
  OTHER = 'other',
}

export const DEFAULT_DATE_FORMAT = 'DD.MM.YY';
export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_FORMAT_RU = 'DD.MM.YYYY';

export const relevanceOptions: ISelectOption[] = [
  { label: 'Другое значение', value: RELEVANCES.OTHER },
  { label: 'За сегодня', value: RELEVANCES.ONE_DAY },
  { label: 'За три дня', value: RELEVANCES.THREE_DAYS },
  { label: 'За неделю', value: RELEVANCES.ONE_WEEK },
  { label: 'За 30 дней', value: RELEVANCES.ONE_MONTH },
  { label: 'За 90 дней', value: RELEVANCES.THREE_MONTHS },
  { label: 'За шесть месяцев', value: RELEVANCES.SIX_MONTHS },
  { label: 'За год', value: RELEVANCES.ONE_YEAR },
  { label: 'За все время', value: RELEVANCES.ALL_TIME },
];

export enum TimePeriods {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year',
}
